import React from 'react'

import { IntlProvider, addLocaleData } from 'react-intl'
import { Provider } from 'react-redux'

import { store, history } from './redux/store'
import { getLocale } from './util/Localizer'
import moment from 'moment'
import 'moment/locale/fr'

import Base from './components/base'
import Login from './components/Login'
import MultiPolicyPage from './components/MultiPolicyPage'
import Member from './components/Member'
import Resources from './components/Resources'
import Claims from './components/Claims'
import Providers from './components/Providers'
import AssociatedClaimLines from './components/AssociatedClaimLines'
import ClaimLineDetails from './components/ClaimLineDetails'
import ServerErrorPage from './components/ServerError'
import Activate from './components/Activate'
import ActivationComplete from './components/ActivationComplete'
import SubmitAClaim from './components/SubmitAClaim'
import UserProfile from './components/UserProfile'
import NotFound from './components/NotFound'
import FAQ from './components/FAQ'
import ForgotPassword from './components/ForgotPassword'
import RetrievePassword from './widgets/ForgotPassword/RetrievePassword'
import BenefitHistory from './widgets/Member/benefitsWidgets/BenefitHistory'

import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles' // new theme

import Snackbar from '@material-ui/core/Snackbar'
import SnackbarContent from '@material-ui/core/SnackbarContent'

import MatchWhenAuthorized from './auth/MatchWhenAuthorized'
import Analytics from './util/analytics/Analytics'

import Config from './Config'

import en from 'react-intl/locale-data/en'
import es from 'react-intl/locale-data/fr'
import enMessages from './intl/en.json'
import esMessages from './intl/fr.json'
import MuiThemeOverrides from './muiTheme'

import { Route, Switch } from 'react-router-dom'
import { ConnectedRouter } from 'connected-react-router'

import { MuiPickersUtilsProvider } from 'material-ui-pickers'
import MomentUtils from '@date-io/moment'

// setup the local
addLocaleData([...en, ...es])
const languageWithoutRegionCode = getLocale()
const messages = languageWithoutRegionCode === 'en' ? enMessages : esMessages
const formats = {
  number: {
    CAD: {
      style: 'currency',
      currency: 'CAD'
    }
  }
}

moment.locale(languageWithoutRegionCode)

const muiTheme = createMuiTheme(Object.assign({}, MuiThemeOverrides))

class Root extends React.Component {
  constructor () {
    super()

    this.openSnackbar = this.openSnackbar.bind(this)
    this.closeSnackbar = this.closeSnackbar.bind(this)

    this.state = {
      snackbarProps: { open: false },
      snackbarContentProps: {}
    }
  }

  componentDidMount () {
    window.addEventListener('root.openSnackbar', this.openSnackbar)
    window.addEventListener('root.closeSnackbar', this.closeSnackbar)
  }

  componentWillUnmount () {
    window.removeEventListener('root.openSnackbar', this.openSnackbar)
    window.removeEventListener('root.closeSnackbar', this.closeSnackbar)
  }

  render () {
    return (
      <Provider store={store}>
        <Base>
          <IntlProvider locale={languageWithoutRegionCode + '-ca'} messages={messages} formats={formats} defaultFormats={formats}>
            <MuiPickersUtilsProvider utils={MomentUtils}>
              <ConnectedRouter history={history}>
                <MuiThemeProvider theme={muiTheme}>
                  <div>
                    <Analytics config={Config} />
                    <Switch>
                      <Route path='/' exact component={Login} />
                      <MatchWhenAuthorized path='/MultiPolicy' exact component={MultiPolicyPage} />
                      <Route path='/ForgotPassword' component={ForgotPassword} />
                      <Route path='/RetrievePassword' component={RetrievePassword} />
                      <Route path='/Activate' exact component={Activate} />
                      <Route path='/ActivationComplete' exact component={ActivationComplete} />
                      <Route path='/FAQ' exact component={FAQ} />
                      <Route path='/servererror' component={ServerErrorPage} />

                      <MatchWhenAuthorized path='/Member/:tab/:lowerTab/:type/History' component={Member} />
                      <MatchWhenAuthorized path='/Member/:tab/:lowerTab/:typeId/:type' component={Member} />
                      <MatchWhenAuthorized path='/Member/:tab/:lowerTab' component={Member} />
                      <MatchWhenAuthorized path='/Member/:tab' component={Member} />
                      <MatchWhenAuthorized path='/Member' component={Member} />
                      <MatchWhenAuthorized path='/SubmitAClaim' component={SubmitAClaim} />
                      <MatchWhenAuthorized path='/History' exact component={BenefitHistory} />
                      <MatchWhenAuthorized path='/Resources' exact component={Resources} />
                      <MatchWhenAuthorized path='/Providers' component={Providers} />
                      <MatchWhenAuthorized path='/Claims' exact component={Claims} />
                      <MatchWhenAuthorized path='/Claims/:claimId/:claimType/ClaimLines' component={Claims} />
                      <MatchWhenAuthorized path='/Claims/:claimId/:claimType/ClaimLines/Details/:claimLineId' component={ClaimLineDetails} />
                      <MatchWhenAuthorized path='/UserProfile' exact component={UserProfile} />
                      <MatchWhenAuthorized path='/AssociatedClaimLines' exact component={AssociatedClaimLines} />
                      <Route component={NotFound} />
                    </Switch>

                    <Snackbar { ...this.state.snackbarProps }>
                      <SnackbarContent { ...this.state.snackbarContentProps } />
                    </Snackbar>

                  </div>
                </MuiThemeProvider>
              </ConnectedRouter>
            </MuiPickersUtilsProvider>
          </IntlProvider>
        </Base>
      </Provider>
    )
  }

  openSnackbar (event) {
    const { detail = {} } = event
    const { props = {}, contentProps = {} } = detail

    this.setState({
      snackbarProps: { ...props, open: true },
      snackbarContentProps: contentProps
    })
  }

  closeSnackbar () {
    this.setState({
      snackbarProps: { open: false },
      snackbarContentProps: {}
    })
  }
}

export default Root



// WEBPACK FOOTER //
// ./src/root.js